module.exports = __webpack_public_path__ + "img/os-dashboard.34b6d699.svg";